import PropTypes from "prop-types";
import { Draggable as DndDraggable } from "react-beautiful-dnd";

export function Draggable({ children, draggableId, index }: any) {
  return (
    <DndDraggable draggableId={draggableId} index={index}>
      {children}
    </DndDraggable>
  );
}

Draggable.propTypes = {
  children: PropTypes.any,
  draggableId: PropTypes.string,
  index: PropTypes.number,
};
